<div>
  <div class="modal-header">
    <h4 class="modal-title" translate>page.controles.evaluation-jure.title</h4>
  </div>
  <div class="modal-body">
    <div class="row mb-2">
      <div class="col-6 d-flex">
        <strong class="label w-40 fw-bold" translate>page.controles.evaluation-jure.numero-anonymat</strong>
        <div >{{ currentLeurre.numeroAnonymat }}</div>
      </div>
      <div class="col-6 d-flex">
        <strong class="label w-40 fw-bold" translate>page.controles.evaluation-jure.type-leurre</strong>
        <div>{{ currentLeurre.libelleTypeLeurre }}</div>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-6 d-flex">
        <strong class="label w-40 fw-bold" translate>page.controles.evaluation-jure.produit</strong>
        <div>{{ currentLeurre.libelleProduit }}</div>
      </div>
      <div class="col-6 d-flex">
        <strong class="label w-40 fw-bold" translate>page.controles.evaluation-jure.conditionnement</strong>
        <div>{{ currentLeurre.libelleConditionnement }}</div>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-6 d-flex">
        <strong class="label w-40 fw-bold" translate>page.controles.evaluation-jure.millesime</strong>
        <div>{{ currentLeurre.millesime }}</div>
      </div>
      <div class="col-6 d-flex">
        <strong class="label w-40 fw-bold" translate>page.controles.evaluation-jure.defauts</strong>
        <div>{{ currentLeurre.defauts.join(', ') }}</div>
      </div>
    </div>

    <!-- Messages d'information -->
    <div *ngIf="isResult && jures?.length === 0" class="alert alert-warning alert-block" translate>
      <fa-icon icon="exclamation"></fa-icon>
      page.controles.evaluation-jure.warning-jure
    </div>

    <div *ngIf="isResult && critereEvaluationJure?.length === 0" class="alert alert-warning alert-block" translate>
      <fa-icon icon="exclamation"></fa-icon>
      page.controles.evaluation-jure.warning-critères
    </div>

    <!-- Tableau d'évaluation -->
    <table class="table mt-3" aria-label="Tableau d'évaluation des jurés" *ngIf="jures?.length > 0 && critereEvaluationJure?.length > 0">
      <thead>
        <th translate>page.controles.evaluation-jure.jures</th>
        <ng-container *ngFor="let critere of critereEvaluationJure">
          <th>{{ critere.libelleCritere }}</th>
        </ng-container>
      </thead>
      <tbody>
        <tr *ngFor="let jure of jures">
          <td>{{ jure.nom }}</td>
          <ng-container *ngFor="let critere of critereEvaluationJure">
            <td>
              <div class="d-flex align-items-center">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" [name]="'critere-'+critere.id+'-'+jure.idJure" [id]="'critere-'+critere.id+'-'+jure.idJure+'-oui'" [value]="true" [(ngModel)]="getEvaluation(jure.idJure, critere.id).valeurOui">
                  <label class="form-check-label" [for]="'critere-'+critere.id+'-'+jure.idJure+'-oui'">Oui</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" [name]="'critere-'+critere.id+'-'+jure.idJure" [id]="'critere-'+critere.id+'-'+jure.idJure+'-non'" [value]="false" [(ngModel)]="getEvaluation(jure.idJure, critere.id).valeurOui">
                  <label class="form-check-label" [for]="'critere-'+critere.id+'-'+jure.idJure+'-non'">Non</label>
                </div>
              </div>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
    <div class="actions-bar">
      <button type="button" (click)="onClose()" class="btn btn-light me-2" translate>label.annuler</button>
      <button type="submit" (click)="onValidateEvaluation()" [disabled]="!canValidate()" class="btn btn-primary" translate>label.valider</button>
    </div>
  </div>
</div>

